<template>
  <v-footer app>
    Copyright© 2015-{{ new Date().getFullYear() }} Dot Incorporation. All rights
    reserved. Terms&Condition Privacy Policy
  </v-footer>
</template>
